import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'xn-checkbox',
  standalone: false,
  templateUrl: './checkbox.html',
  styleUrl: './checkbox.sass',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Checkbox),
      multi: true
    }
  ]
})
export class Checkbox implements ControlValueAccessor {
  
  @Input('binary') binary?: boolean;
  @Input('label') label: string = '';
  @Input('inputId') inputId: string = '';
  @Input('name') name: string = '';
  @Input('disabled') disabled: boolean = false;
  @Input('readonly') readonly: boolean = false;
  @Input('value') value: any;
  _value: any;

  writeValue(value: any): void {
    this._value = value;
  }

  propagateChange = (_: any) => {

  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    
  }

  setDisabledState?(isDisabled: boolean): void {
    
  }

  _onValueChange(event: any){
    this._value = event;
    this.propagateChange(event);
  }
}
